import { login, getInfo, logout } from '@/axios/common'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import router, {
  resetRouter
} from '@/router'
// import store from '@/store'
const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  status: 0,
  merchant_id: '',
  applyStatus: -2, // 登录客户的审核状态 0未提交   1已提交  2已通过  3未通过
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_HZROUTER: (state, hzrouter) => {
    state.hzrouter = hzrouter
  },
  SET_STATUS: (state, status) => {
    state.status = status
  },
  SET_MERCHANT: (state, merchant_id) => {
    state.merchant_id = merchant_id
  },
  SET_APPLY_STATUS: (state, applyStatus) => {
    state.applyStatus = applyStatus
  }
}

const actions = {
  // user login
  login({
    commit
  }, userInfo) {
    const {
      username,
      password,
      uuid
    } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password,
        uuid: uuid
      }).then(response => {
        if (response.code != 200) {
          reject();
        }
        let data = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        // let flag = 0;
        let pattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/
        if (!pattern.test(password)) {
          commit('SET_STATUS', 1)
        } else {
          commit('SET_STATUS', 0)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        // const { data } = response
        let data = JSON.parse(response.data)
        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const {
          roles,
          name,
          merchant_id,
          avatar,
          introduction,
          hzrouter,
          apply_status
        } = data
        // let roles = []
        // roles.push(data.roles)
        // let name = data.name
        // let avatar = ''
        // let introduction = ''
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }
        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        commit('SET_HZROUTER', hzrouter)
        commit('SET_MERCHANT', merchant_id)
        commit('SET_APPLY_STATUS', apply_status)
        console.log(roles);

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRegisterStatus({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        // const { data } = response
        let data = JSON.parse(response.data)
        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const {
          apply_status
        } = data
        commit('SET_APPLY_STATUS', apply_status)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({
    commit,
    state,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_APPLY_STATUS', -2)
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles({
    commit,
    dispatch
  }, role) {
    return new Promise(async (resolve) => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const {
        roles
      } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, {
        root: true
      })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, {
        root: true
      })

      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
